export const THEATER_COLORS = {
  "nordiskfilm": '#5656bb',
  "spegeln": '#2c412f',
  "filmstaden": '#cc0028',
  "panora": '#E09436'
}
